import { Link } from 'react-router-dom';

/** The KeepInvesting lockup — shared by the marketing nav and the auth panel. */
export default function Wordmark({ style }) {
  return (
    <Link className="logo" to="/" style={style}>
      <img src="https://www.bolodhan.com/static/media/logo.10869f06f88ad0ba3ad6.png" alt="boloDhan" />
      <span className="word">Keep<em>Investing</em></span>
    </Link>
  );
}
